export const useGlobalStore = defineStore('globalStore', {
  state() {
    return {
      appConfig: {},
    }
  },
  actions: {
    async initializationGlobal() {
      const deviceStore = useDeviceStore()
      await deviceStore.initialization()
    },
    async initializationServerOnly() {},
    async initializationClientOnly() {},
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGlobalStore, import.meta.hot))
}
